import { Dispatch, SetStateAction } from 'react';
import { SecondaryButton } from '../../../../../../../components/SecondaryButton';
import useGetGeneralAppData from '../../../../../../../hooks/useGetGeneralAppData';
import { PeriodType } from '../../../../types';
import { HeaderContainer } from './styles';

interface IHeader {
  selectedPeriod: PeriodType;
  setChangePeriodModalShow: Dispatch<SetStateAction<boolean>>;
  setDownloadOtimizationBaseModalShow: Dispatch<SetStateAction<boolean>>;
}

export default function Header({
  selectedPeriod,
  setChangePeriodModalShow,
  setDownloadOtimizationBaseModalShow,
}: IHeader) {
  const monthsMap: { [key: number]: string } = {
    1: 'Janeiro',
    2: 'Fevereiro',
    3: 'Março',
    4: 'Abril',
    5: 'Maio',
    6: 'Junho',
    7: 'Julho',
    8: 'Agosto',
    9: 'Setembro',
    10: 'Outubro',
    11: 'Novembro',
    12: 'Dezembro',
  };
  const { permissions } = useGetGeneralAppData();
  const routingPermissions = permissions.find((x) => x.codPag === 6);

  return (
    <HeaderContainer>
      <h6>
        Dashboard {monthsMap[selectedPeriod.month]} de {selectedPeriod.year}
      </h6>

      <div>
        <SecondaryButton onClick={() => setChangePeriodModalShow(true)}>
          Alterar Período
        </SecondaryButton>
        {routingPermissions?.imprimir && (
          <SecondaryButton onClick={() => setDownloadOtimizationBaseModalShow(true)}>
            Download Relatório Otimização
          </SecondaryButton>
        )}
      </div>
    </HeaderContainer>
  );
}
